export default __webpack_public_path__ + "static/media/vip-icon-active.f626861b.webp";